import { render, staticRenderFns } from "./returnfeeLists.vue?vue&type=template&id=2b6b230a&scoped=true&"
import script from "./returnfeeLists.vue?vue&type=script&lang=js&"
export * from "./returnfeeLists.vue?vue&type=script&lang=js&"
import style0 from "./returnfeeLists.vue?vue&type=style&index=0&id=2b6b230a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6b230a",
  null
  
)

export default component.exports